import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { publicRequest, userRequest } from "../utils";

const initialState = {
  cars: [],
  spares: [],
  carDetails: {},
  spareDetails: {},
  newCars: [],
  locations: [],
  categories: [],
  email: null,
  userDetails: {},
  access: null,
  refresh: null,
  myCars: [],
  mySpares: [],
  brandList: [],
  modelList: [],
  message: "",
  remainingTime: "",
  error: "",
  lang: "ru",
};

export const getCarList = createAsyncThunk("cars/getCarList", async () => {
  try {
    const { data } = await publicRequest.get(`vehicle/vehicles/`);
    return data;
  } catch (error) {
    console.log(error);
  }
});

export const getAllSpares = createAsyncThunk(
  "spares/getSpareList",
  async () => {
    try {
      const { data } = await publicRequest.get(`spares/list/`);
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getCarDetails = createAsyncThunk(
  "cars/getCarDetails",
  async (id) => {
    try {
      const { data } = await publicRequest.get(`vehicle/vehicles/${id}/`);
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getSpareDetails = createAsyncThunk(
  "spares/getSpareDetails",
  async (id) => {
    try {
      const { data } = await publicRequest.get(`spares/list/${id}/`);
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getNewCars = createAsyncThunk("cars/getNewCars", async () => {
  try {
    const { data } = await publicRequest.get(`vehicle/new-vehicles/`);
    return data;
  } catch (error) {
    console.log(error);
  }
});

export const getCarsByCategory = createAsyncThunk(
  "cars/getCarsByCategory",
  async (id) => {
    try {
      const { data } = await publicRequest.get(`vehicle/type/${id}/`);
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getCarsBySubcategory = createAsyncThunk(
  "cars/getCarsBySubcategory",
  async ({ activeCategory, activeSubcategory }) => {
    try {
      const { data } = await publicRequest.get(
        `vehicle/type/${activeCategory}/subtype/${activeSubcategory}/`
      );
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getLocation = createAsyncThunk("cars/getLocation", async () => {
  try {
    const { data } = await publicRequest.get(`vehicle/locations/`);
    return data;
  } catch (error) {
    console.log(error);
  }
});

export const getBrandList = createAsyncThunk("vehicle/brands/", async () => {
  try {
    const { data } = await publicRequest.get(`vehicle/brands/`);
    return data;
  } catch (error) {
    console.log(error);
  }
});

export const getModelList = createAsyncThunk("vehicle/models/", async () => {
  try {
    const { data } = await publicRequest.get(`vehicle/models/`);
    return data;
  } catch (error) {
    console.log(error);
  }
});

export const filterCars = createAsyncThunk(
  "cars/filterCars",
  async (params) => {
    try {
      const { data } = await publicRequest.post(`vehicle/filters/`, params);
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getVehicleParentTypes = createAsyncThunk(
  "vehicle/parent_types/",
  async (params) => {
    try {
      const { data } = await publicRequest.post(
        `vehicle/parent_types/`,
        params
      );
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getCarsCategories = createAsyncThunk(
  "cars/parent_types/",
  async () => {
    try {
      const { data } = await publicRequest.get(`vehicle/parent_types/`);
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const addCar = createAsyncThunk(
  "cars/addCar",
  async (params, { getState }) => {
    try {
      const access = getState().cars.access;
      const { data } = await userRequest.post(`vehicle/add/`, params, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access}`,
        },
      });
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const upCar = createAsyncThunk(
  "cars/upCar",
  async (id, { getState, rejectWithValue }) => {
    try {
      const access = getState().cars.access;
      const { data } = await userRequest.post(
        `vehicle/owner/${id}/up/`,
        {},
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data.error || error.message);
    }
  }
);

export const addUrgentVipToCar = createAsyncThunk(
  "cars/addUrgentVipToCar",
  async ({ id, params }, { getState, rejectWithValue }) => {
    try {
      const access = getState().cars.access;
      const { data } = await userRequest.put(`vehicle/${id}/status/`, params, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data.error || error.message);
    }
  }
);

export const addComment = createAsyncThunk(
  "cars/addComment",
  async (params, { getState }) => {
    try {
      const access = getState().cars.access;
      const { data } = await userRequest.post(`vehicle/comments/`, params, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      });
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const addSpares = createAsyncThunk(
  "spares/addSpares",
  async (params, { getState }) => {
    try {
      const access = getState().cars.access;
      const { data } = await userRequest.post(`spares/create/`, params, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access}`,
        },
      });
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const updateCar = createAsyncThunk(
  "cars/updateCar",
  async ({ id, data }, { getState }) => {
    try {
      const access = getState().cars.access;
      const { res } = await userRequest.patch(`vehicle/update/${id}/`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access}`,
        },
      });
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const deleteCarImages = createAsyncThunk(
  "cars/deleteCarImages",
  async (params, { getState }) => {
    try {
      const access = getState().cars.access;
      const { image_ids } = params;
      const { data } = await userRequest.delete("vehicle/images/delete/", {
        data: { image_ids },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      });

      return data;
    } catch (error) {
      console.log("err", error);
    }
  }
);

export const deleteSpareImages = createAsyncThunk(
  "cars/deleteSpareImages",
  async (params, { getState }) => {
    try {
      const { image_ids } = params;
      const access = getState().cars.access;
      const { data } = await userRequest.delete(
        "spares/images/delete/",

        {
          data: { image_ids },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access}`,
          },
        }
      );

      return data;
    } catch (error) {
      console.log("err", error);
    }
  }
);

export const updateSpare = createAsyncThunk(
  "spares/updateSpare",
  async ({ id, data }, { getState }) => {
    try {
      const access = getState().cars.access;
      const { res } = await userRequest.patch(`spares/update/${id}/`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access}`,
        },
      });
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getMyCars = createAsyncThunk(
  "cars/getMyCars",
  async (_, { getState }) => {
    try {
      const access = getState().cars.access;
      const { data } = await userRequest.get(`vehicle/myuploaded/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      });
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getMySpares = createAsyncThunk(
  "spares/getMySpares",
  async (_, { getState }) => {
    try {
      const access = getState().cars.access;
      const { data } = await userRequest.get(`spares/owners/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      });
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const register = createAsyncThunk(
  "user/register",
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await publicRequest.post(`user/register/`, params);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data.message || error.message);
    }
  }
);

export const login = createAsyncThunk(
  "user/login",
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await publicRequest.post(`user/login/`, params);

      return data;
    } catch (error) {
      return rejectWithValue(error.response.data.message || error.message);
    }
  }
);

export const verifyOTP = createAsyncThunk(
  "user/verifyOTP",
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await publicRequest.post(`user/verify-otp/`, params);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data.message || error.message);
    }
  }
);

export const requestOtpToResetPassword = createAsyncThunk(
  "user/requestOtpToResetPassword",
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await publicRequest.post(
        `user/passw-reset-otp-request/`,
        params
      );
      return data;
    } catch (error) {
      console.log("error", error);
      return rejectWithValue(
        error.response.data.message || error.response.data.error
      );
    }
  }
);

export const resetPassword = createAsyncThunk(
  "user/resetPassword",
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await publicRequest.post(`user/reset-password/`, params);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || error.response.data.error
      );
    }
  }
);

export const resendOTP = createAsyncThunk(
  "user/resendOtp",
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await publicRequest.post(`user/resend-otp/`, params);
      return data;
    } catch (error) {
      console.log("error", error);
      return rejectWithValue({
        message: error.response.data.error,
        remaining_time: error.response.data.remaining_time,
      });
    }
  }
);

export const searchCars = createAsyncThunk(
  "cars/searchCars",
  async (params) => {
    try {
      const { data } = await publicRequest.post(
        `vehicle/vehicles/search/`,
        params
      );
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getUser = createAsyncThunk(
  "user/getUser",
  async (_, { getState }) => {
    try {
      const access = getState().cars.access;
      const { data } = await userRequest.get(`user/user-details/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      });
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const updateUser = createAsyncThunk(
  "user/updateUser",
  async (params, { rejectWithValue, getState }) => {
    try {
      const access = getState().cars.access;
      const { data } = await userRequest.put(`user/update-details/`, params, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access}`,
        },
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data.message || error.message);
    }
  }
);

export const carSlice = createSlice({
  name: "cars",
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.clear();
      state.user = null;
      state.email = null;
      state.userDetails = {};
    },
    setLang(state, action) {
      state.lang = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getCarList.fulfilled, (state, action) => {
        state.cars = action.payload;
        state.loading = false;
      })

      .addCase(getAllSpares.fulfilled, (state, action) => {
        state.spares = action.payload;
        state.loading = false;
      })

      .addCase(getCarDetails.fulfilled, (state, action) => {
        state.carDetails = action.payload;
      })

      .addCase(getSpareDetails.fulfilled, (state, action) => {
        state.spareDetails = action.payload;
      })

      .addCase(getCarsByCategory.fulfilled, (state, action) => {
        state.cars = action.payload;
        state.loading = false;
      })

      .addCase(getCarsBySubcategory.fulfilled, (state, action) => {
        state.cars = action.payload;
        state.loading = false;
      })

      .addCase(getNewCars.fulfilled, (state, action) => {
        state.newCars = action.payload;
        state.loading = false;
      })

      .addCase(getLocation.fulfilled, (state, action) => {
        state.locations = action.payload;
        state.loading = false;
      })

      .addCase(filterCars.fulfilled, (state, action) => {
        state.cars = action.payload;
        state.loading = false;
      })

      .addCase(getCarsCategories.fulfilled, (state, action) => {
        state.categories = action.payload;
        state.loading = false;
      })

      .addCase(addCar.fulfilled, (state, action) => {
        state.myCars = action.payload;
        state.loading = false;
      })

      .addCase(addSpares.fulfilled, (state, action) => {
        state.mySpares = action.payload;
        state.loading = false;
      })

      .addCase(getMySpares.fulfilled, (state, action) => {
        state.mySpares = action.payload;
        state.loading = false;
      })

      .addCase(searchCars.fulfilled, (state, action) => {
        state.cars = action.payload;
        state.loading = false;
      })

      .addCase(register.fulfilled, (state, action) => {
        state.email = action.payload?.email;
        state.message = action.payload?.message;
        state.remainingTime = action.payload?.remaining_time;
      })

      .addCase(login.fulfilled, (state, action) => {
        state.access = action.payload.access;
        state.refresh = action.payload.refresh;
        state.email = action.payload.email;
        localStorage.clear();
        localStorage.setItem("access_token", action.payload.access);
        localStorage.setItem("refresh_token", action.payload.refresh);
      })

      .addCase(verifyOTP.fulfilled, (state, action) => {
        state.access = action.payload.access;
        state.refresh = action.payload.refresh;
        state.loading = false;
        state.email = action.payload.email;
        state.message = action.payload?.message;
      })

      .addCase(resetPassword.fulfilled, (state, action) => {
        state.message = action.payload?.message;
        state.remainingTime = action.payload?.remaining_time;
        state.error = action.payload?.error;
      })

      .addCase(requestOtpToResetPassword.fulfilled, (state, action) => {
        state.email = action.payload?.email;
        state.remainingTime = action.payload?.remaining_time;
        state.message = action.payload?.message;
      })

      .addCase(resendOTP.fulfilled, (state, action) => {
        state.message = action.payload.message;
        state.error = action?.payload?.error;
        state.remainingTime = action?.payload?.remaining_time;
      })

      .addCase(getMyCars.fulfilled, (state, action) => {
        state.myCars = action.payload;
      })

      .addCase(getBrandList.fulfilled, (state, action) => {
        state.brandList = action.payload;
      })

      .addCase(getModelList.fulfilled, (state, action) => {
        state.modelList = action.payload;
      })

      .addCase(getUser.fulfilled, (state, action) => {
        state.userDetails = action.payload;
      })

      .addCase(updateUser.fulfilled, (state, action) => {
        state.userDetails = action.payload;
      });
  },
});

export default carSlice.reducer;
export const { logout, setLang } = carSlice.actions;
